<template>
    <yams-template>
        <template #header>
            <div class="mr-5">
                <h4 class="text-primary font-weight-bold">Demandes ({{ demandes.length }})</h4>
            </div>
            <div class="mr-4">
                <NavOperations></NavOperations>
            </div>
            <div class="px-1">
                <button type="button" class="btn-yams btn-active" @click="openCreateModal()">
                    Ajouter une réservation <i class="fa-solid fa-plus"></i>
                </button>
            </div>
        </template>
        <template #content>
            <div class="container">
                <form class="form-inline mb-4" @submit.prevent="changePeriod()">
                    <input class="form-control form-control-sm" type="month" id="start" name="start" min="2018-03"
                        v-model="form.period" />
                    <button type="submit" class="ml-2 btn btn-sm btn-primary">
                        <i class="fa-solid fa-magnifying-glass"></i> Charger 
                    </button>
                </form>
                <ProgressBar v-if="isLoading === true" mode="indeterminate" style="height: 6px; margin-bottom: 10px;"></ProgressBar>
                <p v-if="isEmpty == true" class="text-center"> Vous n'avez pas de course ce mois</p>
                <div class="card mb-3 shadow-2 " v-for="demande in demandes" :key="demande.id"
                    @click="openShowModal(demande)">
                    <div class=" card-body">
                        <div class="row">
                            <div class="col-md">
                                <p class="text-secondary">Numero</p>
                                <strong>#DEA0{{ demande.id }}</strong>
                            </div>
                            <!-- <div class="col-md">
                                <p class="text-secondary">Type</p>
                                <strong>{{ demande.type_course }}</strong>
                            </div> -->
                            <div class="col-md-5 text-center">
                                <p class="text-secondary">Trajet</p>
                                <strong>{{ demande.adresse_chargement }} ({{ formatDate(demande.date_chargement) }})</strong> - 
                                <strong>{{demande.adresse_dechargement }}</strong>
                                <strong v-if="demande.date_dechargement">({{ formatDate(demande.date_dechargement) }})</strong>
                            </div>
                            <div class="col-md">
                                <p class="text-secondary">Montant</p>
                                <strong>{{ formatPriceWithDevise(demande.montant) }}</strong>
                            </div>
                            <div class="col-md">
                                <p class="text-secondary">Statut</p>
                                <strong v-if="demande.statut == 'En attente'" class="p-2 rounded-pill badge badge-danger">{{
                                    demande.statut }}</strong>
                                <strong v-else-if="demande.statut == 'Accepté'"
                                    class="p-2 rounded-pill badge badge-success">{{ demande.statut }}</strong>
                                <strong v-else class="p-2 rounded-pill badge badge-secondary ">{{ demande.statut }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </yams-template>
</template>

<script>
import moment from 'moment'
import { defineComponent, defineAsyncComponent } from 'vue';
import NavOperations from '@/views/operations/NavOperations.vue';
const CreateReservation = defineAsyncComponent(() => import('@/views/operations/reservations/CreateReservation.vue'));
const ShowReservation = defineAsyncComponent(() => import('@/views/operations/reservations/ShowReservation.vue'));

export default defineComponent({
    name: 'IndexCourse',
    components: { NavOperations },
    data() {
        return {
            isLoading: false,
            url: '/api/demandes',
            isEmpty: false,
            demandes: [],
            form: {
                period: moment().format('YYYY-MM'),
            },
        };
    },
    mounted() {
        this.getDemandes(this.url)
    },
    methods: {
        formatDate(val) {
            if (val) return moment(String(val)).format('DD/MM/YYYY')
        },
        formatPriceWithDevise(val) {
            if (val) return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'XAF' }).format(val)
        },
        getDemandes(demandesUrl) {
            this.isLoading = true
            this.axios.get(demandesUrl).then((response) => {
                this.demandes = response.data.data
                if (response.data.data.length < 1) {
                    this.isEmpty = true
                }
                this.isLoading = false
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        changePeriod() {
            this.isEmpty = false
            const demandesUrl =  this.url + '?req_period=' + this.form.period
            this.getDemandes(demandesUrl)
        },
        openShowModal(objData) {
            this.$dialog.open(ShowReservation, {
                props: {
                    header: "Demande de course",
                    style: {
                        width: '50vw'
                    },
                    modal: true
                },
                data: objData
            });
        },
        openCreateModal() {
            this.$dialog.open(CreateReservation, {
                props: {
                    header: "Faire une nouvelle réservation",
                    style: {
                        width: '50vw'
                    },
                    modal: true
                }
            });
        },
    }
});
</script>

<style scoped>
.card {
  cursor: pointer;
}
</style>